export const APP_URL = import.meta.env.VITE_APP_URL || "https://app.barmaid.app";

export function appUrl(path: string): string {
  const base = APP_URL.replace(/\/$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}
